import { HeroFrame } from '../types/content';

export const heroFrames: HeroFrame[] = [
  {
    id: 'robot',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/95e8faae-67e0-4b7a-aa18-70ec29043b8e.jpg',
    alt: 'Robot 5 axes sculptant un visage monumental dans un bloc de polystyrène',
    process: 'Robot 5 axes',
    detail: 'Sculpture EPS densifié · 4,20 m',
    intensity: 0.35,
  },
  {
    id: 'cnc',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/c905a287-3936-4b65-a17f-1c528a710279.jpg',
    alt: 'Broche CNC usinant un panneau de bois pour un décor de scène',
    process: 'Usinage CNC',
    detail: 'Contreplaqué 30 mm · passe de finition',
    intensity: 0.25,
  },
  {
    id: 'plasma',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/bd79819d-7ec4-4394-8900-054f9e4a5fee.jpg',
    alt: 'Découpe plasma d’une tôle d’acier avec gerbe d’étincelles',
    process: 'Découpe plasma',
    detail: 'Acier S235 · épaisseur 15 mm',
    intensity: 1,
  },
  {
    id: 'resin',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/9a1910b6-7b5a-405c-b9f0-af4cd113ad4a.jpg',
    alt: 'Opérateur projetant de la résine sur une sculpture monumentale',
    process: 'Projection résine',
    detail: 'Polyurée Polyspray · 3 mm',
    intensity: 0.15,
  },
];
